import React, { useEffect, useState } from 'react';
import './index.css';
import clsx from 'classnames';
import { ImageLoader, Loading, Position } from 'components';
import { useParams } from 'react-router-dom';
import Nav from '../components/Nav';
import { useAppContext } from 'context';
import ProductItem from '../components/ProductItem';
import { usePageTitle, useProductDetail, useProductList } from '../../../hooks';
import { useLocation } from 'react-router-dom';

// 顶部背景图
const bannerList = [
  {
    img: '/img/productBig.jpg',
    className: 'product-detail-top-banner-big',
  },
  {
    img: '/img/productSmall.jpg',
    className: 'product-detail-top-banner-small',
  },
];

const ProductDetail = () => {
  const { id } = useParams();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const isNew = query.get('isNew');
  const [pageTitle, setPageTitle] = useState('');
  // 设置页面标题 - 使用产品名称
  usePageTitle(pageTitle);

  const [productTypeList, setProductTypeList] = useState([]);
  // 获取产品列表数据
  const {
    data: list,
    loading: listLoading,
    error: listError,
    refresh: listRefresh,
  } = useProductList();
  // 类型列
  const clist = list?.clist;
  // 产品列
  const dlist = list?.dlist;
  const { data, loading, error, refresh } = useProductDetail(id);

  useEffect(() => {
    if (data) {
      setPageTitle(`${data?.model}${data?.name}`);
    }
  }, [data]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const {
    state: { type },
    dispatch,
  } = useAppContext();

  useEffect(() => {
    if (id && !listLoading) {
      dispatch({
        type: 'SET_PRODUCT_TYPE',
        // 路由isNew有值并且详情isnew为1时，则显示最新产品
        payload: isNew && data?.isnew === '1' ? 'new' : data?.cid,
      });
    }
    if (list) {
      setProductTypeList([...list?.clist, { name: '最新产品', cid: 'new' }]);
    }
  }, [id, dispatch, listLoading, data, list, isNew]);

  // 错误状态
  if (error || listError) {
    return (
      <div
        className={clsx('news-top')}
        style={{ minHeight: window.innerHeight }}
      >
        {/* 顶部Banner */}
        {bannerList.map((v, index) => (
          <img
            key={index}
            src={v.img}
            alt=''
            width={'100%'}
            height={'100%'}
            className={clsx(v.className)}
          />
        ))}
        <Position list={['首页', '产品中心']} />
        <div className='error-container'>
          <p>数据加载失败，请点击重试</p>
          <button
            onClick={() => {
              listRefresh();
              refresh();
            }}
          >
            重试
          </button>
        </div>
      </div>
    );
  }

  const typeItemName =
    type === 'new' ? '最新产品' : clist?.find((v) => v.cid === type)?.name;
  // 同类型的前四个（排除当前产品）
  const sameTypeList = dlist
    ?.filter((v) => v.cid === data?.cid && v.id !== data?.id)
    .slice(0, 4);
  // 所有产品的前四个（排除当前产品）
  const firstFourList = dlist?.filter((v) => v.id !== data?.id).slice(0, 4);
  // 根据产品类型进行查找，如果找该产品同类型的产品少于4个，则显示所有产品的前四个，否则显示同类型产品前四个（排除当前产品）
  const getNewList = (arr) => {
    const newList = arr?.map((v) => {
      return { ...v, cid: isNew ? 'new' : v.cid };
    });
    return newList;
  };
  const showProductList =
    sameTypeList?.length < 4
      ? getNewList(firstFourList)
      : getNewList(sameTypeList);

  return (
    <div
      className={clsx('product-detail-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      {bannerList.map((v, index) => (
        <img
          key={index}
          src={v.img}
          alt=''
          width={'100%'}
          height={'100%'}
          className={clsx(v.className)}
        />
      ))}
      {/* 当前位置 */}
      <Position
        list={['首页', '产品中心', typeItemName]}
        firstType={productTypeList[0]?.cid}
      />
      {/* 产品详情 */}
      {!loading && !listLoading ? (
        <>
          <div className={clsx('product-detail-content')}>
            {/* 左侧导航栏 */}
            <Nav clist={productTypeList} />
            {/* 右侧内容 */}
            {data && (
              <div className={clsx('product-detail-content-detail')}>
                <div className={clsx('product-detail-content-detail-block')}>
                  {data?.imgs[0] && (
                    <ImageLoader
                      src={
                        'https://api.zjzyfwq.com' + data?.imgs[0]?.url.slice(4)
                      }
                      alt={data?.name}
                      width={'100%'}
                      height={'100%'}
                      id={data?.id}
                    />
                  )}
                </div>
                <div className={clsx('product-detail-content-detail-desc')}>
                  <div
                    className={clsx('product-detail-content-detail-desc-title')}
                  >
                    一、概述
                  </div>
                  <div
                    dangerouslySetInnerHTML={{ __html: data?.desc }}
                    className={clsx('product-detail-content-detail-desc-text')}
                  />
                </div>
                <div className={clsx('product-detail-content-detail-params')}>
                  <div
                    className={clsx('product-detail-content-detail-desc-title')}
                  >
                    二、主要技术参数
                  </div>
                  <div
                    className={clsx(
                      'product-detail-content-detail-params-list',
                    )}
                  >
                    {data?.params.map((item, index) => (
                      <div
                        className={clsx(
                          'product-detail-content-detail-params-list-item',
                        )}
                        key={index}
                      >
                        {`${index + 1}、${item.name}：${item.value}`}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* 产品相关推荐  */}
          <div className={clsx('product-detail-related')}>
            <div className={clsx('product-detail-related-title')}>相关推荐</div>
            <div className={clsx('product-detail-related-list')}>
              {showProductList?.map((v, index) => (
                <ProductItem key={index} item={v} lineNumber={4} />
              ))}
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default ProductDetail;
